import { render, staticRenderFns } from "./ActiveSubstanceBtns.vue?vue&type=template&id=40cbd4f5&"
import script from "./ActiveSubstanceBtns.vue?vue&type=script&lang=js&"
export * from "./ActiveSubstanceBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports